import React from 'react';

import { MdError } from 'react-icons/md';

import { Container } from './styles';

function ExceptionsBox({ exceptions }) {
  return (
    <Container>
      {exceptions?.map((value, index) => {
        const [keys] = value;

        return (
          <div key={`${index}-${keys?.parameter}`}>
            <div className="iconException">
              <MdError size={20} color="#cc0000" />
            </div>
            <div className="exceptionsBoxContent">
              <strong>{keys?.parameter}: </strong>
              <span> {keys?.exception} </span>
            </div>
          </div>
        );
      })}
    </Container>
  );
}

export default ExceptionsBox;
